import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var defaultFetchOptions = function defaultFetchOptions(cors) {
  var options = {
    cache: "no-cache",
    credentials: "include",
    redirect: "follow",
    referrer: "no-referrer"
  };

  if (cors) {
    options.mode = "cors";
  }

  return options;
};

export var userlogin = function userlogin(apiBase, cors, jwt) {
  var requestJson = {
    tokenId: jwt
  };
  return fetch("".concat(apiBase, "/userlogin"), _objectSpread(_objectSpread({}, defaultFetchOptions(cors)), {}, {
    body: JSON.stringify(requestJson),
    method: "POST",
    headers: {
      "content-type": "application/json"
    }
  }));
};
export var userlogout = function userlogout(apiBase, cors) {
  return fetch("".concat(apiBase, "/userlogout"), _objectSpread(_objectSpread({}, defaultFetchOptions(cors)), {}, {
    method: "POST",
    headers: {
      "content-type": "application/json"
    }
  }));
};
export var getuserdetails = function getuserdetails(apiBase, cors) {
  return fetch("".concat(apiBase, "/getuserdetails"), _objectSpread({}, defaultFetchOptions(cors)));
};